import {omneticApi} from '@dms/api/base';
import {BaseVoidRequestSchema} from '@dms/api/shared';

import {
  CompleteAiVehicleServiceIntervalApiArg,
  CompleteAiVehicleServiceIntervalApiArgSchema,
  CompleteAiVehicleServiceIntervalApiResponse,
  CompleteAiVehicleServiceIntervalApiResponseSchema,
  FailAiVehicleServiceIntervalApiArg,
  FailAiVehicleServiceIntervalApiResponse,
  FailAiVehicleServiceIntervalApiResponseSchema,
  GetLatestAiVehicleServiceIntervalsApiArg,
  GetLatestAiVehicleServiceIntervalsApiResponse,
  GetLatestAiVehicleServiceIntervalsApiResponseSchema,
  InitializeAiVehicleServiceIntervalsApiArg,
  InitializeAiVehicleServiceIntervalsApiResponse,
  InitializeAiVehicleServiceIntervalsApiResponseSchema,
} from './types';

export const aiVehicleServiceIntervalsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    completeAiVehicleServiceInterval: build.mutation<
      CompleteAiVehicleServiceIntervalApiResponse,
      CompleteAiVehicleServiceIntervalApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-service-intervals/${queryArg.aiVehicleServiceIntervalId}/complete`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'AiVehicleServiceIntervals', id: queryArg.aiVehicleServiceIntervalId},
      ],
      extraOptions: {
        responseSchema: CompleteAiVehicleServiceIntervalApiResponseSchema,
        requestSchema: CompleteAiVehicleServiceIntervalApiArgSchema,
      },
    }),
    failAiVehicleServiceInterval: build.mutation<
      FailAiVehicleServiceIntervalApiResponse,
      FailAiVehicleServiceIntervalApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-service-intervals/${queryArg.aiVehicleServiceIntervalId}/fail`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'AiVehicleServiceIntervals', id: queryArg.aiVehicleServiceIntervalId},
      ],
      extraOptions: {
        responseSchema: FailAiVehicleServiceIntervalApiResponseSchema,
        requestSchema: BaseVoidRequestSchema,
      },
    }),
    getLatestAiVehicleServiceIntervals: build.query<
      GetLatestAiVehicleServiceIntervalsApiResponse,
      GetLatestAiVehicleServiceIntervalsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/ai-service-intervals/latest`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'AiVehicleServiceIntervals', id: `vehicle-${queryArg.vehicleId}`},
      ],
      extraOptions: {
        responseSchema: GetLatestAiVehicleServiceIntervalsApiResponseSchema,
        requestSchema: BaseVoidRequestSchema,
      },
    }),
    initializeAiVehicleServiceIntervals: build.mutation<
      InitializeAiVehicleServiceIntervalsApiResponse,
      InitializeAiVehicleServiceIntervalsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/ai-service-intervals/initialize`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'AiVehicleServiceIntervals', id: `vehicle-${queryArg.vehicleId}`},
      ],
      extraOptions: {
        responseSchema: InitializeAiVehicleServiceIntervalsApiResponseSchema,
        requestSchema: BaseVoidRequestSchema,
      },
    }),
  }),
});

export const {
  useCompleteAiVehicleServiceIntervalMutation,
  useFailAiVehicleServiceIntervalMutation,
  useGetLatestAiVehicleServiceIntervalsQuery,
  useInitializeAiVehicleServiceIntervalsMutation,
} = aiVehicleServiceIntervalsApi;
